/**
 * Törzsadat endpointok FE wrapperje (read-only).
 * A FE az aktív csoportot az AuthProvider.myGroups-ból veszi, így itt
 * csak az intézmény és a diák-lista lekérése kell.
 */

import type { Institution, Student } from '@pta/types';
import { apiCall } from './client';

// -------- Institutions --------

export function fetchInstitution(id: number): Promise<Institution> {
  return apiCall(`/institutions/${id}`);
}

// -------- Students --------

/**
 * Egy csoport aktuális tagjai (nyitott membership-pel).
 * Opcionális `asOf` ISO datám — a BE az adott napon érvényes membership-eket adja.
 */
export function fetchStudentsByGroup(
  groupId: number,
  params?: { asOf?: string },
): Promise<Student[]> {
  return apiCall(`/groups/${groupId}/students`, {
    query: {
      asOf: params?.asOf,
    },
  });
}
